import React, { useState, useEffect } from 'react';
import Filter from '../components/Filter';
import { TextInput2 } from '../components/TextInput2';
import './../css/filtermarketpricedb.scss';
import { useDispatch } from 'react-redux';
import {
  getMerk,
  getSeri,
  getTipe,
  getSilinder,
  getModel,
  getTransmisi,
  getGrade,
  getTahun,
  getWarna,
  getKota,
  getKepemilikan,
  getNopolisi,
  getStnk,
} from '../utils/Filter/FilterMpdb';
import { btnMarketprice, onlyAllowNumber, replaceNan } from '../helper';
import { API_FILTER } from '../api/api';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { marketpriceFilterReset } from '../services/amplitude';

export const FilterMarketpriceDb = ({ onSearch, page, perPage, loading, selected }) => {
  const [error, setError] = useState({
    minKm: {
      error: false,
      msg: '',
    },
    maxKm: {
      error: false,
      msg: '',
    },
  });
  const [filters, setFilters] = useState({
    merk: [],
    seri: [],
    tipe: [],
    silinder: [],
    kota: [],
    grades: [
      { value: '0', label: 'Pilih Grade' },
      { value: 'A', label: 'Grade A' },
      { value: 'B', label: 'Grade B' },
      { value: 'C', label: 'Grade C' },
      { value: 'D', label: 'Grade D' },
      { value: 'E', label: 'Grade E' },
    ],
    transmisi: [],
    startYear: [],
    endYear: [],
    periodes_data: [
      { value: '0', label: 'Pilih Periode' },
      { value: '1', label: '1 Bulan' },
      { value: '2', label: '2 Bulan' },
      { value: '3', label: '3 Bulan' },
      { value: '4', label: '4 Bulan' },
      { value: '5', label: '5 Bulan' },
      { value: '6', label: '6 Bulan' },
    ],
    model: [],

    warnat: [
      { value: '', label: 'Pilih Warna' },
      { value: '', label: 'Semua Data Warna' },
    ],
    typeskepemilikan: [
      { value: '0', label: 'Pilih Kepemilikan' },
      { value: '1', label: 'Semua Data Kepemilikan' },
    ],
    nopolisis: [
      { value: '0', label: 'Pilih No Polisi' },
      { value: '1', label: 'Semua Data No Polisi' },
    ],

    stnks: [
      { value: '', label: 'Pilih STNK' },
      { value: '', label: 'Semua Data STNK' },
    ],
    bpkbs: [
      {
        value: '',
        label: 'Pilih BPKB',
      },
      {
        value: '7',
        label: '≤ 7 hari kerja',
      },
      {
        value: '14',
        label: '8-14 hari kerja',
      },
      {
        value: '30',
        label: '15-30 hari kerja',
      },
      {
        value: '31',
        label: '> 30 hari kerja',
      },
    ],
  });

  const [selectedValue, setSelected] = useState({
    merk: selected.brand,
    seri: selected.series,
    tipe: selected.type,
    silinder: selected.cylinder,
    kota: selected.city,
    grade: selected.grade,
    transmisi: selected.transmission,
    startYear: selected.startYear,
    endYear: selected.endYear,
    periode_data: selected.period,
    model: selected.model,
    warna: selected.color,
    typekepemilikan: selected.Kepemilikan,
    nopolisi: selected.platNo,
    stnk: selected.stnk,
    bpkb: selected.bpkb,
    minKm: selected.minKm,
    maxKm: selected.maxKm,
    page: selected.page,
    perPage: selected.perPage,
  });

  const temp_res = {
    merk: [],
    seri: [],
    tipe: [],
    silinder: [],
    kota: [],
    grades: [
      { value: '0', label: 'Pilih Grade' },
      { value: 'A', label: 'Grade A' },
      { value: 'B', label: 'Grade B' },
      { value: 'C', label: 'Grade C' },
      { value: 'D', label: 'Grade D' },
      { value: 'E', label: 'Grade E' },
    ],
    transmisi: [],
    startYear: [],
    endYear: [],
    periodes_data: [
      { value: '0', label: 'Pilih Periode' },
      { value: '1', label: '1 Bulan' },
      { value: '2', label: '2 Bulan' },
      { value: '3', label: '3 Bulan' },
      { value: '4', label: '4 Bulan' },
      { value: '5', label: '5 Bulan' },
      { value: '6', label: '6 Bulan' },
    ],
    model: [],
    warnat: [
      { value: '', label: 'Pilih Warna' },
      { value: '', label: 'Semua Data Warna' },
    ],
    typeskepemilikan: [
      { value: '0', label: 'Pilih Kepemilikan' },
      { value: '1', label: 'Semua Data Kepemilikan' },
    ],
    nopolisis: [
      { value: '0', label: 'Pilih No Polisi' },
      { value: '1', label: 'Semua Data No Polisi' },
    ],

    stnks: [
      { value: '', label: 'Pilih STNK' },
      { value: '', label: 'Semua Data STNK' },
    ],
    bpkbs: [
      {
        value: '',
        label: 'Pilih BPKB',
      },
      {
        value: '7',
        label: '≤ 7 hari kerja',
      },
      {
        value: '14',
        label: '8-14 hari kerja',
      },
      {
        value: '30',
        label: '15-30 hari kerja',
      },
      {
        value: '31',
        label: '> 30 hari kerja',
      },
    ],
  };

  const dispatch = useDispatch();

  function filterByYear(value) {
    return value.value >= selectedValue.startYear;
  }

  function buttonDisabled() {
    return btnMarketprice(selectedValue, error);
  }

  const onCariHarga = () => {
    dispatch({
      type: 'SET_SELECTED_MARKETPRICE',
      value: {
        city: selectedValue.kota,
        location: selectedValue.kota,
        transmission: selectedValue.transmisi,
        startYear: selectedValue.startYear,
        endYear: selectedValue.endYear,
        period: selectedValue.periode_data,
        model: selectedValue.model,
        brand: selectedValue.merk,
        series: selectedValue.seri,
        cylinder: selectedValue.silinder,
        type: selectedValue.tipe,
        grade: selectedValue.grade,
        color: selectedValue.warna,
        Kepemilikan: selectedValue.typekepemilikan,
        nopolisi: selectedValue.nopolisi,
        stnk: selectedValue.stnk,
        bpkb: selectedValue.bpkb,
        page: page,
        perPage: perPage,
        minKm: selectedValue.minKm,
        maxKm: selectedValue.maxKm,
      },
    });

    const data = {
      brand: selectedValue.merk,
      city: selectedValue.kota,
      location: selectedValue.kota,
      cylinder: selectedValue.silinder,
      model: selectedValue.model,
      ownerType: selectedValue.typekepemilikan,
      period: selectedValue.periode_data,
      platNo: selectedValue.nopolisi,
      series: selectedValue.seri,
      stnk: selectedValue.stnk,
      bpkb: selectedValue.bpkb,
      type: selectedValue.tipe,
      grade: selectedValue.grade,
      transmission: selectedValue.transmisi,
      startYear: selectedValue.startYear,
      endYear: selectedValue.endYear,
      color: selectedValue.warna,
      page: page,
      perPage: perPage,
      minKm: selectedValue.minKm,
      maxKm: selectedValue.maxKm,
    };
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    };
    onSearch({ data, config });
  };

  useEffect(() => {
    Promise.all([
      getMerk().then((res) => {
        temp_res.merk = res;
      }),

      getSeri(selectedValue.merk).then((res) => {
        temp_res.seri = res;
      }),

      getTipe(selectedValue.merk, selectedValue.seri).then((res) => {
        temp_res.tipe = res;
      }),

      getSilinder(selectedValue.merk, selectedValue.seri, selectedValue.tipe).then((res) => {
        temp_res.silinder = res;
      }),
      getModel(selectedValue.merk, selectedValue.seri).then((res) => {
        temp_res.model = res;
      }),

      getTahun(
        selectedValue.merk,
        selectedValue.seri,
        selectedValue.tipe,
        selectedValue.silinder,
        selectedValue.periode_data,
        selectedValue.transmisi,
        selectedValue.grade
      ).then((res) => {
        temp_res.startYear = res;
        temp_res.endYear = res;
      }),

      getKota(
        selectedValue.merk,
        selectedValue.seri,
        selectedValue.tipe,
        selectedValue.silinder,
        selectedValue.startYear,
        selectedValue.endYear
      ).then((res) => {
        temp_res.kota = res;
      }),

      getTransmisi(selectedValue.merk, selectedValue.seri).then((res) => {
        temp_res.transmisi = res;
      }),

      getModel(selectedValue.merk, selectedValue.seri).then((res) => {
        temp_res.model = res;
      }),

      getGrade(selectedValue.merk, selectedValue.seri).then((res) => {
        temp_res.grades = res;
      }),

      getWarna(selectedValue.merk, selectedValue.seri).then((res) => {
        temp_res.warnat = res;
      }),

      getKepemilikan(selectedValue.merk, selectedValue.seri, selectedValue.kota).then((res) => {
        temp_res.kepemilikan = res;
      }),

      getNopolisi(selectedValue.merk, selectedValue.kota, selectedValue.seri).then((res) => {
        temp_res.nopolisis = res;
      }),

      getStnk(selectedValue.merk, selectedValue.seri, selectedValue.kota).then((res) => {
        temp_res.stnks = res;
      }),
    ]).then((res) => {
      setFilters(temp_res);
    });
  }, []);

  useEffect(() => {
    if (selectedValue.minKm && selectedValue.maxKm) {
      if (parseInt(selectedValue.maxKm) < parseInt(selectedValue.minKm)) {
        setError({
          ...error,
          maxKm: {
            error: true,
            msg: 'Nilai akhir harus lebih besar.',
          },
        });
      } else {
        setError({
          ...error,
          maxKm: {
            error: false,
            msg: '',
          },
        });
      }
    } else {
      setError({
        ...error,
        maxKm: {
          error: false,
          msg: '',
        },
      });
    }
  }, [selectedValue.minKm, selectedValue.maxKm]);

  const fetchComplimentaryData = async (event) => {
    let kepemilikan = await axios.get(
      API_FILTER.filter +
      `kepemilikan?merk=${selectedValue.merk}&seri=${selectedValue.seri}&lokasi=${event.target.value}`
    );

    let nopol = await axios.get(
      API_FILTER.filter + `nopolisi?merk=${selectedValue.merk}&lokasi=${event.target.value}&seri=${selectedValue.seri}`
    );

    let stnk = await axios.get(
      API_FILTER.filter + `stnk?merk=${selectedValue.merk}&seri=${selectedValue.seri}&lokasi=${event.target.value}`
    );

    axios.all([kepemilikan, nopol, stnk]).then(
      axios.spread((...allData) => {
        let dataKepemilikan = allData[0].data.data;
        let dataNopol = allData[1].data.data;
        let stnk = allData[2].data.data;

        dataKepemilikan.unshift({ value: '', label: 'Pilih Kepemilikan' });
        dataNopol.unshift({ value: '', label: 'Pilih Nomor Polisi' });
        stnk.unshift({ value: '', label: 'Pilih STNK' });

        setFilters({
          ...filters,
          typeskepemilikan: dataKepemilikan,
          nopolisis: dataNopol,
          stnks: stnk,
        });
      })
    );
  };

  const onChange = (event) => {
    switch (event.target.name) {
      case 'merk':
        getSeri(event.target.value).then((res) => {
          setSelected({ merk: event.target.value });
          setFilters({ ...filters, seri: res });
        });
        break;

      case 'seri':
        getTipe(selectedValue.merk, event.target.value).then((res) => {
          setSelected({ ...selectedValue, seri: event.target.value });
          setFilters({ ...filters, tipe: res });
        });
        break;

      case 'tipe':
        getSilinder(selectedValue.merk, selectedValue.seri, event.target.value).then((res) => {
          setSelected({ ...selectedValue, tipe: event.target.value });
          setFilters({ ...filters, silinder: res });
        });
        break;

      case 'silinder':
        setSelected({ ...selectedValue, silinder: event.target.value });
        break;

      case 'periode_data':
        getModel(selectedValue.merk, selectedValue.seri).then((res) => {
          setSelected({ ...selectedValue, periode_data: event.target.value });
          setFilters({ ...filters, model: res });
        });
        break;

      case 'transmisi':
        getGrade(selectedValue.merk, selectedValue.seri).then((res) => {
          setSelected({ ...selectedValue, transmisi: event.target.value });
          setFilters({ ...filters, grades: res });
        });
        break;

      case 'grade':
        getTahun(
          selectedValue.merk,
          selectedValue.seri,
          selectedValue.tipe,
          selectedValue.silinder,
          selectedValue.periode_data,
          selectedValue.transmisi,
          event.target.value
        ).then((res) => {
          setSelected({ ...selectedValue, grade: event.target.value });
          setFilters({ ...filters, startYear: res, endYear: res });
        });
        break;

      case 'startYear':
        getWarna(selectedValue.merk, selectedValue.seri).then((val) => {
          setFilters({ ...filters, warnat: val });
        });
        setSelected({ ...selectedValue, startYear: event.target.value });

        break;

      case 'endYear':
        getKota(
          selectedValue.merk,
          selectedValue.seri,
          selectedValue.tipe,
          selectedValue.silinder,
          selectedValue.startYear,
          event.target.value
        ).then((res) => {
          setFilters({ ...filters, kota: res });
        });
        setSelected({
          ...selectedValue,
          endYear: event.target.value,
        });

        break;

      case 'warna':
        setSelected({ ...selectedValue, warna: event.target.value });

        break;

      case 'kota':
        setSelected({ ...selectedValue, kota: event.target.value });
        fetchComplimentaryData(event);
        break;

      case 'stnk':
        setSelected({ ...selectedValue, stnk: event.target.value });
        break;

      case 'bpkb':
        setSelected({
          ...selectedValue,
          bpkb: event.target.value,
        });
        break;

      case 'kepemilikan':
        setSelected({ ...selectedValue, typekepemilikan: event.target.value });
        getStnk(selectedValue.merk, selectedValue.seri, selectedValue.kota).then((res) => {
          setFilters({ ...filters, stnks: res });
        });
        break;

      case 'nopolisi':
        setSelected({
          ...selectedValue,
          nopolisi: event.target.value,
        });
        break;

      case 'periode_data':
        getModel(
          selectedValue.merk,
          selectedValue.seri,
          selectedValue.tipe,
          selectedValue.silinder,
          selectedValue.periode_data,
          event.target.value
        ).then((res) => {
          setSelected({ ...selectedValue, periode_data: event.target.value });
          setFilters({ ...filters, model: res });
        });
        break;

      case 'model':
        getTransmisi(selectedValue.merk, selectedValue.seri).then((res) => {
          setSelected({
            ...selectedValue,
            model: event.target.value,
          });
          setFilters({
            ...filters,
            transmisi: res,
          });
        });
        break;
    }
  };

  const onReset = () => {
    setFilters({
      merk: [],
      seri: [],
      tipe: [],
      silinder: [],
      periodes_data: [],
      model: [],
      transmisi: [],
      grades: [],
      startYear: [],
      endYear: [],
      warnat: [],
      kota: [],
      typeskepemilikan: [],
      nopolisis: [],
      stnks: [],
    });

    getMerk().then((res) => {
      setFilters({ ...filters, merk: res, endYear: [{ value: '', label: 'Pilih Tahun' }] });
    });

    setSelected({
      merk: null,
      seri: null,
      tipe: null,
      silinder: null,
      periode_data: null,
      model: null,
      grade: null,
      transmisi: null,
      startYear: null,
      endYear: null,
      tahun: null,
      warna: null,
      kepemilikan: null,
      kota: null,
      nopolisi: null,
      stnk: null,
      minKm: '',
      maxKm: '',
    });

    marketpriceFilterReset();
  };

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 d-lg-block d-md-block d-sm-none">
      <div>
        <h4 className="title2 ml-0"></h4>

        <p className="mt-4 ml-0 title">Kendaraan</p>
        <span className="hr"></span>
        <div className="form-row horizontal mt-3">
          <Filter
            disabled={false}
            selected={selectedValue.merk}
            name="merk"
            options={filters.merk}
            onChange={(event) => {
              onChange(event);
            }}
            label="Merek *"
          />
          <Filter
            disabled={selectedValue.merk != null || selectedValue.merk === '' ? false : true}
            selected={selectedValue.seri}
            options={filters.seri}
            name="seri"
            onChange={(event) => {
              onChange(event);
            }}
            label="Seri *"
          />
          <Filter
            disabled={selectedValue.seri != null ? false : true}
            selected={selectedValue.tipe}
            options={filters.tipe}
            name="tipe"
            onChange={(event) => {
              onChange(event);
            }}
            label="Tipe *"
          />
          <Filter
            disabled={selectedValue.tipe != null ? false : true}
            selected={selectedValue.silinder}
            options={filters.silinder}
            name="silinder"
            onChange={(event) => {
              onChange(event);
            }}
            label="Silinder *"
          />
        </div>

        <div className="form-row mt-1">
          <Filter
            disabled={selectedValue.silinder != null ? false : true}
            selected={selectedValue.periode_data}
            options={filters.periodes_data}
            name="periode_data"
            onChange={(event) => {
              onChange(event);
            }}
            label="Periode Data *"
          />
          <Filter
            disabled={
              selectedValue.periode_data === undefined ||
              selectedValue.periode_data === null ||
              selectedValue.periode_data === '0'
            }
            selected={selectedValue.model}
            options={filters.model}
            name="model"
            onChange={(event) => {
              onChange(event);
            }}
            label="Model *"
          />
          <Filter
            disabled={
              selectedValue.periode_data === undefined ||
              selectedValue.periode_data === null ||
              selectedValue.periode_data === '0'
            }
            selected={selectedValue.transmisi}
            options={filters.transmisi}
            name="transmisi"
            onChange={(event) => {
              onChange(event);
            }}
            label="Transmisi *"
          />
        </div>
        <p className="mt-4 ml-0 title">Spesifikasi Kendaraan</p>
        <span className="hr2"></span>
        <div className="form-row horizontal mt-3">
          <Filter
            disabled={selectedValue.transmisi != null ? false : true}
            selected={selectedValue.grade}
            name="grade"
            options={filters.grades}
            onChange={(event) => {
              onChange(event);
            }}
            label="Grade *"
          />
          <Filter
            disabled={selectedValue.grade === undefined || selectedValue.grade === null || selectedValue.grade === '0'}
            selected={selectedValue.startYear}
            options={filters.startYear}
            name="startYear"
            onChange={(event) => {
              onChange(event);
            }}
            label="Tahun Awal *"
          />
          <Filter
            disabled={
              selectedValue.startYear === undefined ||
              selectedValue.startYear === null ||
              selectedValue.startYear === 'label'
            }
            selected={selectedValue.endYear}
            options={filters.endYear !== undefined ? filters.endYear.filter(filterByYear) : filters.startYear}
            name="endYear"
            onChange={(event) => {
              onChange(event);
            }}
            label="Tahun Akhir *"
          />

          <Filter
            disabled={selectedValue.startYear != null ? false : true}
            selected={selectedValue.warna}
            name="warna"
            options={filters.warnat}
            onChange={(event) => {
              onChange(event);
            }}
            label="Warna"
          />
        </div>
        <div className="form-row mt-1 d-flex flex-row align-item-start mb-2">
          <div className="col-lg-3 col-md-12 pl-0">
            <label style={{ fontSize: 12, fontWeight: 400 }}>Odo Meter</label>
            <NumberFormat
              name="minKm"
              className="form-control shadow-none outline-none mb-2"
              placeholder="Odo Meter Awal"
              allowNegative={false}
              onKeyPress={(e) => onlyAllowNumber(e)}
              onInput={(e) => replaceNan(e)}
              value={selectedValue.minKm}
              thousandSeparator={'.'}
              decimalSeparator={false}
              onValueChange={(values) => {
                setSelected({
                  ...selectedValue,
                  minKm: values.value,
                });
              }}
            />
          </div>
          <div className="col-lg-3 col-md-12 pl-0 mb-2 align-self-end position-relative">
            <NumberFormat
              name="maxKm"
              className={`form-control shadow-none outline-none ${error.maxKm.error ? 'border-danger' : ''}`}
              placeholder="Odo Meter Akhir"
              allowNegative={false}
              onKeyPress={(e) => onlyAllowNumber(e)}
              onInput={(e) => replaceNan(e)}
              value={selectedValue.maxKm}
              thousandSeparator={'.'}
              decimalSeparator={false}
              onValueChange={(values) => {
                setSelected({
                  ...selectedValue,
                  maxKm: values.value,
                });
              }}
            />
            {error.maxKm.msg && (
              <p
                style={{ fontSize: 13, color: 'red', fontWeight: 600, paddingLeft: '0.75rem', bottom: '-1.25rem' }}
                className="position-absolute m-0"
              >
                {error.maxKm.msg}
              </p>
            )}
          </div>
        </div>
        <p className="mt-4 ml-0 title">Perihal lelang Kendaraan</p>
        <span className="hr3"></span>

        <div className="form-row horizontal mt-3">
          <Filter
            disabled={selectedValue.startYear != null ? false : true}
            selected={selectedValue.kota}
            name="kota"
            options={filters.kota}
            onChange={(event) => {
              onChange(event);
            }}
            label="Kota *"
          />
          <Filter
            disabled={selectedValue.kota != null && selectedValue.kota !== 'label' ? false : true}
            selected={selectedValue.typekepemilikan}
            name="kepemilikan"
            options={filters.typeskepemilikan}
            onChange={(event) => {
              onChange(event);
            }}
            label="Kepemilikan"
          />
          <Filter
            disabled={selectedValue.kota != null && selectedValue.kota !== 'label' ? false : true}
            selected={selectedValue.nopolisi}
            name="nopolisi"
            options={filters.nopolisis}
            onChange={(event) => {
              onChange(event);
            }}
            label="Plat Nomor"
          />
          <Filter
            disabled={selectedValue.kota != null && selectedValue.kota !== 'label' ? false : true}
            selected={selectedValue.stnk}
            name="stnk"
            options={filters.stnks}
            onChange={(event) => {
              onChange(event);
            }}
            label="STNK"
          />
          <Filter
            disabled={selectedValue.kota != null && selectedValue.kota !== 'label' ? false : true}
            selected={selectedValue.bpkb}
            name="bpkb"
            options={filters.bpkbs}
            onChange={(event) => {
              onChange(event);
            }}
            label="BPKB"
          />
          {/* <Filter
            disabled={false}
            name="kepemilikan"
            options={filters.kepemilikan}
            placeholder="semua kepemilikan"
            onChange={(event) => {
              onChange(event);
            }}
            label="Kepemilikan *"
          />  
          <Filter
            disabled={false}
            name="nopolisi"
            placeholder="semua nopol "
            onChange={(event) => {
              onChange(event);
            }}
            label="Plat Nomor *"
          />
          <Filter
            disabled={false}
            options={filters.stnk}
            name="stnk"
            onChange={(event) => {
              onChange(event);
            }}
            label="STNK *"
          /> */}
        </div>
      </div>
      <div className="col-lg-12 mt-5 col-md-12 d-flex justify-content-end align-items-end">
        <div className="form-row mb-5">
          <div className="col-6">
            <button className="btn-marketprice-red" onClick={onReset}>
              Atur Ulang Filter
            </button>
          </div>

          <div className="col-6">
            <button
              className="btn-marketprice-green-solid"
              disabled={buttonDisabled() || loading}
              onClick={onCariHarga}
            >
              {loading ? 'Loading...' : 'Cari Harga'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterMarketpriceDb;
